import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  background?: 'dark' | 'light' | 'navy';
  id?: string;
}
export function Section({
  children,
  className = '',
  background = 'light',
  id
}: SectionProps) {
  const bgColors = {
    dark: 'bg-[#0f1923] text-[#f0ebe3]',
    navy: 'bg-[#1a2740] text-[#f0ebe3]',
    light: 'bg-[#faf6f0] text-[#1a2332]'
  };
  return <section id={id} className={`py-10 md:py-16 ${bgColors[background]} ${className}`} data-id="element-216">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="container mx-auto px-6 md:px-8 max-w-4xl" data-id="element-217">
        {children}
      </motion.div>
    </section>;
}